import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import InputCameraPage from "InputCameraPage";

export const AppRoutes = () => (
  <Router>
    <Routes>
      <Route path="/" element={<InputCameraPage />} />
    </Routes>
  </Router>
);

export default AppRoutes;
